import React, { FC } from 'react'
import { connect } from 'react-redux'
import { setUIAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import FooterMobile from '../../FooterMobile'
import Cargo from '../../../assets/CargoCombinedVertLogo.png'
import './languageSelection.less'
import { useTranslation } from 'react-i18next'
import eng from '../../../assets/flags/eng.png'
import fin from '../../../assets/flags/fin.png'
import est from '../../../assets/flags/est.png'
import sve from '../../../assets/flags/sve.png'
import lat from '../../../assets/flags/lat.png'
import rus from '../../../assets/flags/rus.png'
import pol from '../../../assets/flags/pol.png'

const langs = [
    { img: eng, code: 'en' },
    { img: est, code: 'et' },
    { img: fin, code: 'fi' },
    { img: sve, code: 'sv' },
    { img: lat, code: 'lv' },
    { img: rus, code: 'ru' },
    { img: pol, code: 'pl' },
]

interface DispatchProps {
    setUI: (ui: UI) => void
}
const mapDispatchToProps = (dispatch: any): DispatchProps => ({
    setUI: (ui: UI): void => dispatch(setUIAction(ui)),
})
type Props = DispatchProps

const LanguageSelection: FC<Props> = ({ setUI }) => {
    const { i18n, t } = useTranslation()

    const onClickFlag = (code: string) => {
        i18n.changeLanguage(code)
        setUI(UI.WELCOME)
    }

    return (
        <div className="language-selection-mobile">
            <div className="main">
                <div className="logo-container">
                    <img className="logo" src={Cargo} alt="cargo" />
                </div>
                <div className="title">CHECK-IN</div>
                <div className="flags-container">
                    {langs.map((item, index) => (
                        !(index % 2) && <div key={item.code} className="flags-row">
                            <img
                                className="flag"
                                src={item.img}
                                alt="flag"
                                onClick={() => onClickFlag(item.code)}
                            />
                            {!!langs[index + 1] && <img
                                className="flag"
                                src={langs[index + 1].img}
                                alt="flag"
                                onClick={() => onClickFlag(langs[index + 1].code)}
                            />}
                        </div>
                    ))}
                </div>
            </div>
            <div className="language-selection-footer">
                <FooterMobile />
            </div>
        </div>
    )
}

export default connect(null, mapDispatchToProps)(LanguageSelection)